import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";

import useNdcList from "./hooks/useNdcList";

const NdcList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const ndcListData = useNdcList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={ndcListData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {ndcListData.screen_title} -{" "}
          <span className="heading-cod">{ndcListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={ndcListData.formFields}
        dropdownValues={ndcListData.dropdownValues}
        paramsData={ndcListData.paramsData}
        updataParamData={ndcListData.updateParamData}
      />
      <ButtonsSection ctaButtons={ndcListData.ctaButtons} />
      <DisplayTable
        data={ndcListData.data}
        parmKey={ndcListData.parmKey}
        menuOptions={ndcListData.menuOptions}
        tableHeaders={ndcListData.columnDef}
        setRowData={ndcListData.setRowData}
        selectedPriceSchedules={ndcListData.selectedRows}
        setSelectedPriceSchedules={ndcListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={ndcListData.first}
          rows={ndcListData.rows}
          totalRecords={ndcListData.totalRecords}
          currentPage={ndcListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={ndcListData.onPageChange}
        />
      </div>
      {ndcListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={ndcListData.isConfirmationModalOpen}
          onRequestClose={ndcListData.closeConfirmationModal}
          onBack={ndcListData.closeConfirmationModal}
          onSave={ndcListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={ndcListData.setSelectedOption}
        />
      )}
      {ndcListData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={ndcListData.isHideConfirmationModalOpen}
          onRequestClose={ndcListData.closeHideConfirmationModal}
          onBack={ndcListData.closeHideConfirmationModal}
          onSave={ndcListData.hidePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={ndcListData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default NdcList;
